export default "__VITE_ASSET__CiihgSof__"